export const globalSelf = typeof self === "undefined" ? undefined : self;